import { ProBlueprintsGallery } from 'pro-gallery';
import LeanGalleryWrapper from '../LeanGalleryWrapper/BlueprintsLeanGalleryWrapper';

export default class ProGallerySantaWrapper extends LeanGalleryWrapper {
  getGalleryComponent() {
    return ProBlueprintsGallery;
  }
}
